import { Link } from 'react-router-dom';
import MovieCard from '@/components/base/MovieCard';
import type { Movie } from '@/mocks/movies';

interface MovieSectionProps {
  title: string;
  subtitle: string;
  icon: string;
  movies: Movie[];
  linkTo?: string;
  linkLabel?: string;
  showHeat?: boolean;
}

export default function MovieSection({
  title,
  subtitle,
  icon,
  movies,
  linkTo,
  linkLabel = '查看全部',
  showHeat = false,
}: MovieSectionProps) {
  return (
    <section className="mx-auto px-4 py-10 md:px-10 md:py-14">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
            <i className={`${icon} text-xl`}></i>
          </span>
          <div>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              {title}
            </h2>
            <p className="mt-0.5 text-sm text-foreground-600">{subtitle}</p>
          </div>
        </div>
        {linkTo && (
          <Link
            to={linkTo}
            className="whitespace-nowrap cursor-pointer rounded-md px-3 py-2 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100"
          >
            {linkLabel}
            <i className="ri-arrow-right-s-line ml-1 align-middle"></i>
          </Link>
        )}
      </div>

      {movies.length === 0 ? (
        <div className="mt-6 flex flex-col items-center justify-center rounded-lg bg-background-100 py-16 text-center ring-1 ring-background-200/70">
          <i className="ri-inbox-line text-4xl text-foreground-300"></i>
          <p className="mt-3 text-sm text-foreground-600">暂无相关影视资源</p>
        </div>
      ) : (
        <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 md:gap-5 lg:grid-cols-5">
          {movies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} showHeat={showHeat} />
          ))}
        </div>
      )}
    </section>
  );
}